import { QueryClient } from '@tanstack/react-query';

/**
 * 管理コンソール全体で共有する QueryClient。
 *
 * - staleTime: 60 秒（管理画面のデータ鮮度のバランス）
 * - gcTime: 5 分（タブ切替での再利用を許容）
 * - retry: 2 回まで自動リトライ
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      gcTime: 5 * 60 * 1000,
      retry: 2,
      refetchOnWindowFocus: true,
    },
  },
});
